import {useEffect} from 'react';
import {usePathname, useSearchParams} from 'next/navigation';
import {NEXT_PUBLIC_YM_COUNTER_NUMBER} from 'core/helpers/env';

export default function YandexMetrika() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        const query = searchParams?.toString?.() ?? '';
        const url = query ? `${pathname}?${query}` : (pathname ?? '/');
        if ('function' === typeof ym) {
            ym(NEXT_PUBLIC_YM_COUNTER_NUMBER, 'hit', url);
        }
    }, [pathname, searchParams]);

    return null;
}
